import LoginSvc from '@/services/login';
// import AnalysisSvc from '@/services/analysis';

const BEHAVIOR_VERIFY_DATA_KEY = 'BEHAVIOR_VERIFY_DATA';
const BEHAVIOR_VERIFY_URL = '/mobile/behavior/verify/?from=h5';

export default {
  data() {
    return {
      code: '',
      sended: !1,
      count: 60,
    };
  },
  computed: {
    codeError() {
      if (!this.getError && !this.validators) return '';
      return this.getError(this.validators.code, {
        required: '请输入验证码',
        number: '验证码应为数字',
      });
    },
    verifyInvalid() {
      return this.sended ||
      (this.validators && this.validators.phone && !this.validators.phone.$valid);
    },
    verifyTxt() {
      return this.sended ? `已发送（${this.count}）` : '获取验证码';
    },
    trackEventOrigin() {
      switch (this.$options.name) {
        case 'Login': return 'web_login';
        case 'Reset': return 'web_reset';
        case 'Register': return 'web_register';
        case 'Bind': return 'web_bind';
        default: return '';
      }
    },
  },
  mounted() {
    this.verifyButton = document.getElementById('captchaBox');
    if (this.verifyButton) {
      this.verifyButton.addEventListener('click', this.getVerifyCode);
    }
  },
  beforeDestroy() {
    if (this.verifyButton) {
      this.verifyButton.removeEventListener('click', this.getVerifyCode);
    }
  },
  methods: {
    getVerifyCode(event) {
      if (event && event.preventDefault) event.preventDefault();
      if (this.verifyInvalid || !this.phone || this.sended) return !1;

      const verifyData = window.localStorage.getItem(BEHAVIOR_VERIFY_DATA_KEY);
      if (!verifyData) {
        if (this.beforeBehaviorVerify) this.beforeBehaviorVerify();
        window.location.href = BEHAVIOR_VERIFY_URL;
        return !1;
      }

      let validInfo;
      try {
        validInfo = JSON.parse(verifyData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Invalid behavior verify data', error);
        window.localStorage.removeItem(BEHAVIOR_VERIFY_DATA_KEY);
        window.location.href = BEHAVIOR_VERIFY_URL;
        return !1;
      }

      window.localStorage.removeItem(BEHAVIOR_VERIFY_DATA_KEY);

      return LoginSvc.getVerifyCode({}, {
        area_code: this.area,
        phone: this.phone,
        ...validInfo,
      })
        .then((success) => {
          // eslint-disable-next-line
          if(success){
            this.sended = !0;
            return this.counter();
          }

          return alert('获取验证码失败，请重试。');
        });
    },
    // track(sucessful) {
    //   if (!this.trackEventOrigin) return;
    //   AnalysisSvc.track('GetVerifyCode', {
    //     event_origin: this.trackEventOrigin,
    //     is_success: !!sucessful,
    //   });
    // },
    counter() {
      if (this.count > 0) {
        this.count -= 1;
        this.timer = setTimeout(this.counter, 1000);
      } else {
        this.count = 60;
        this.sended = !1;
        this.timer = null;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/verify.js